export default __webpack_public_path__ + "static/media/travero.678afce8.png";